var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider } from "@material-ui/styles";
import QuizImpl from "./QuizImpl";
import { Provider } from "react-redux";
import createStoreInstance from "../state/store";
import quizzesTheme from "../themes";

var Quiz = function Quiz(props) {
  var store = createStoreInstance(props.id);
  return React.createElement(Provider, {
    store: store
  }, React.createElement(StylesProvider, {
    injectFirst: true
  }, React.createElement(ThemeProvider, {
    theme: quizzesTheme
  }, React.createElement(QuizImpl, __assign({}, props)))));
};

export default Quiz;